import { render, staticRenderFns } from "./CountMessageTemplate.vue?vue&type=template&id=6042c6bc"
import script from "./CountMessageTemplate.vue?vue&type=script&lang=js"
export * from "./CountMessageTemplate.vue?vue&type=script&lang=js"
import style0 from "./CountMessageTemplate.vue?vue&type=style&index=0&id=6042c6bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports